import * as tslib_1 from "tslib";
import selectSkypeNotificationOption from '../data/mutators/selectSkypeNotificationOption';
import SkypeNotificationType from '../data/store/schema/SkypeNotificationType';
import getSkypeOptions from '../data/store/store';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { getFallbackValueIfNull } from 'owa-options-core';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import { getOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
var SkypeNotificationFull = /** @class */ (function (_super) {
    tslib_1.__extends(SkypeNotificationFull, _super);
    function SkypeNotificationFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (option, isImNotification) {
            selectSkypeNotificationOption(_this.getNotificationType(option.key), isImNotification);
        };
        return _this;
    }
    SkypeNotificationFull.prototype.render = function () {
        var _this = this;
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var imNotificationType = getFallbackValueIfNull(optionStore.imNotification, userOptions.skypeMessageNotification).toString();
        var callNotificationType = getFallbackValueIfNull(optionStore.callNotification, userOptions.skypeCallingNotification).toString();
        var choices = [
            {
                key: SkypeNotificationType.ToastAndSound.toString(),
                text: strings.options_skype_NotifyAll,
            },
            {
                key: SkypeNotificationType.ToastOnly.toString(),
                text: strings.options_skype_NotifyToast,
            },
            {
                key: SkypeNotificationType.None.toString(),
                text: strings.options_skype_ImNotifyNone,
            },
        ];
        return (React.createElement("div", null,
            React.createElement(ChoiceGroup, { label: strings.options_skype_ImNotifityTitle, selectedKey: imNotificationType, options: choices, onChange: function (ev, option) {
                    return _this.onChange(option, true /* isImNotification*/);
                } }),
            React.createElement(ChoiceGroup, { label: strings.options_skype_CallNotifityTitle, selectedKey: callNotificationType, options: choices, onChange: function (ev, option) {
                    return _this.onChange(option, false /* isImNotification*/);
                } })));
    };
    SkypeNotificationFull.prototype.getNotificationType = function (num) {
        switch (num) {
            case '1':
                return SkypeNotificationType.ToastAndSound;
            case '2':
                return SkypeNotificationType.ToastOnly;
            default:
                return SkypeNotificationType.None;
        }
    };
    SkypeNotificationFull = tslib_1.__decorate([
        reactive({
            optionStore: function () { return getSkypeOptions(); },
            userOptions: function () {
                return getOptionsForFeature(OwsOptionsFeatureType.SkypeNotifications);
            },
        })
    ], SkypeNotificationFull);
    return SkypeNotificationFull;
}(React.Component));
export default SkypeNotificationFull;
//# sourceMappingURL=SkypeNotificationFull.js.map